import { useSuspenseQuery, queryOptions } from '@tanstack/react-query'
import { SuspenseQueryWith } from '@/utils/types'
import { PointsLeaderboard, LeaderboardResponseSchema } from '@/features/points/logic/types'

export type UsePointsLeaderboardResult = SuspenseQueryWith<{
  pointsLeaderboard: PointsLeaderboard
}>

export function usePointsLeaderboard(): UsePointsLeaderboardResult {
  const res = useSuspenseQuery({
    ...pointsLeaderboardQueryOptions(),
  })

  return {
    ...res,
    pointsLeaderboard: res.data,
  }
}

export function pointsLeaderboardQueryOptions() {
  return queryOptions<PointsLeaderboard>({
    queryKey: ['season-mew', 'points-leaderboard'],
    queryFn: async (): Promise<PointsLeaderboard> => {
      const response = await fetch('/api/points/leaderboard')

      if (!response.ok) {
        throw new Error('Error fetching points leaderboard')
      }
      const json = await response.json()
      return LeaderboardResponseSchema.parse(json)
    },
    staleTime: Number.POSITIVE_INFINITY,
    refetchInterval: false,
  })
}
